import _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { takeUntil, tap } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { LoadingService } from 'app/core/services/loading.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {

  private _statusFilter = 0;
  set statusFilter(statusFilter) {
    this._statusFilter = statusFilter;
  };
  get statusFilter() {
    return this._statusFilter;
  };
  public campaignTypes = [];

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private cookieService: CookieService,
    private loadingService: LoadingService,
  ) { }

  getCampaignList(access_token, options) {
    const token = this.cookieService.get('accessToken');
    const statusFilter = options.statusFilter;
    const campaignTypes = options.campaignTypes;

    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "statusFilter": statusFilter,
        "campaignTypes": campaignTypes,
      }))}`
    ];
    return this.http.post('/api/campaign/list', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getEditCampaignList(access_token, options) {
    const token = this.cookieService.get('accessToken');
    const statusFilter = options.statusFilter;
    const campaignTypes = options.campaignTypes;

    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "statusFilter": statusFilter,
        "campaignTypes": campaignTypes,
      }))}`
    ];
    return this.http.post('/api/edit/campaign/list', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getEventCampaignList(access_token, options) {
    const token = this.cookieService.get('accessToken');
    const statusFilter = options.statusFilter;
    const campaignTypes = options.campaignTypes;

    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "statusFilter": statusFilter,
        "campaignTypes": campaignTypes,
      }))}`
    ];
    return this.http.post('/api/event/campaign/list', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getManageCampaignList(access_token, options) {
    const token = this.cookieService.get('accessToken');
    const statusFilter = options.statusFilter;
    const campaignTypes = options.campaignTypes;

    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "statusFilter": statusFilter,
        "campaignTypes": campaignTypes,
      }))}`
    ];
    return this.http.post('/api/manage/campaign/list', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getReportCampaignList(access_token, options) {
    const token = this.cookieService.get('accessToken');
    const statusFilter = options.statusFilter;
    const campaignTypes = options.campaignTypes;

    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "statusFilter": statusFilter,
        "campaignTypes": campaignTypes,
      }))}`
    ];
    return this.http.post('/api/report/campaign/list', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getPendingCampaignList(access_token, options) {
    const token = this.cookieService.get('accessToken');
    const statusFilter = options.statusFilter;
    const campaignTypes = options.campaignTypes;

    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "statusFilter": statusFilter,
        "campaignTypes": campaignTypes,
      }))}`
    ];
    return this.http.post('/api/pending/campaign/list', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getCampaign(campaignId) {
    const token = this.cookieService.get('accessToken');

    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "campaignId": campaignId,
        "allOptions": true
      }))}`
    ];
    return this.http.post('/api/campaign/detail', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }


  getHinduDateLocations() {
    return this.http.post('/api/getHinduDateLocations', null);
  }

  createCampaign(campaign) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(campaign))}`
    ];
    return this.http.post('/api/campaign/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateCampaign(campaign) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(campaign))}`
    ];
    return this.http.post('/api/campaign/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateCampaignByProperties(campaignId, propertiesToUpdate) {
    const params = {
      campaignId: campaignId,
      properties: propertiesToUpdate,
    }
    
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];

    return this.http.post('/api/campaign/properties/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deepCopyCampaign(data): Observable<any> {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];
    return this.http.post('/api/campaign/clone', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  createNewCampaignWithOptions(data): Observable<any> {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(data))}`
    ];
    return this.http.post('/api/campaign/clone', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deleteCampaign(campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `delete=true`,
      `id=${campaignId}`
    ];
    return this.http.post('/api/campaign/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  activateCampaign(campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `delete=false`,
      `id=${campaignId}`
    ];
    return this.http.post('/api/campaign/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  setStatus(campaignId, newStatus) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({ campaignId, newStatus }))}`
    ];
    return this.http.post('/api/campaign/status/set', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  resetCampaign(campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `campaignId=${campaignId}`
    ];
    return this.http.post('/api/campaign/reset', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  raffleDraw(campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({ campaignId }))}`
    ];
    return this.http.post('/api/ticket/draw', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  addSponsorGroup({ id: campaignId }, { id: sponsorGroupId }) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({campaignId, sponsorGroupId}))}`
    ];
    return this.http.post('/api/campaign/addSponsor', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  configGroup(switchers, form, switcher, controls, takeUntilSubject?): Subscription {
    let switcherName = null,
        switcherValue = true;
    if(_.isObject(switcher)) {
      switcherName = _.get(switcher, 'name', null);
      switcherValue = _.get(switcher, 'value', true);
    } else {
      switcherName = switcher;
    }
    let { valueChanges } = switchers.get(switcherName);
    if(takeUntilSubject) {
      valueChanges = valueChanges.pipe(
        takeUntil(takeUntilSubject)
      );
    };
    return valueChanges.subscribe((value) => {
      _.forEach(controls, (data) => {
        const { name, defaultValue, validators } = data;
        const disabled = _.get(data, 'options.disabled', false);
        const control = form.get(name) as UntypedFormControl;
        if(_.isEqual(value, switcherValue)) {
          control.setValidators(validators);
          if(disabled) {
            control.disable();
          }
        } else {
          control.clearValidators();
          if(disabled) {
            control.enable();
          }
        }
        control.setValue(defaultValue);
        control.markAsPristine();
      });
    });
  }

  configGroup2(form, observed, controls, takeUntilSubject?): Subscription {
    let observedName = null,
    observedValue = true;
    if(_.isObject(observed)) {
      observedName = _.get(observed, 'name', null);
      observedValue = _.get(observed, 'value', true);
    } else {
      observedName = observed;
    }
    let { valueChanges } = form.get(observedName);
    if(takeUntilSubject) {
      valueChanges = valueChanges.pipe(
        takeUntil(takeUntilSubject)
      );
    };
    return valueChanges.subscribe((newValue) => {
      _.forEach(controls, (data) => {
        const { name, value, validators } = data;
        const disabled = _.get(data, 'options.disabled', false);
        const control = form.get(name) as UntypedFormControl;
        if(_.isEqual(newValue, observedValue)) {
          control.setValidators(validators);
          disabled ? control.disable(): control.enable();
          control.setValue(value);
        }
        control.markAsPristine();
      });
    });
  }

  generateForm(form: UntypedFormGroup, structure: any) {
    const arrays = _.get(structure, 'arrays', []);
    _.forEach(arrays, ({ array: name, value, validators }) => {
      const clonedValue = _.cloneDeep(value);
      const array = new UntypedFormArray(clonedValue, validators);
      form.addControl(name, array);
    });

    const fields = _.get(structure, 'fields', []);
    _.forEach(fields, (element) => {
      const name = _.get(element, 'field', '');
      let value = _.get(element, 'value', null);
      if(_.isArray(value)) {
        value = _.cloneDeep(value);
      } else if(_.isFunction(value)) {
        value = value;
      } else if(_.isObject(value)) {
        value = _.cloneDeep(value);
      }
      const validators = _.get(element, 'validators', []);

      const disabled = _.get(element, 'options.disabled', false);

      const control = new UntypedFormControl({
        disabled: _.isFunction(disabled) ? disabled(): disabled,
        value: _.isFunction(value) ? value(): value
      }, validators);
      form.addControl(name, control);
    });

    const groups = _.get(structure, 'groups', []);
    _.forEach(groups, (structure: any) => {
      const { group: name } = structure;

      const group = new UntypedFormGroup({});
      form.addControl(name, group);

      this.generateForm(group, structure);
    });
  }

  transformTo(data: any, structure: any, skipFirstRow: boolean = true) {
    const structureKeys = [];

    let arrays = _.get(structure, 'arrays', []);
    _.forEach(arrays, ({array: key, schema }) => {
      structureKeys.push({type: 'transformTo', key, schema });
    });

    let fields = _.get(structure, 'fields', []);
    _.forEach(fields, ({field: key, type }) => {
      structureKeys.push({type, key });
    });

    const result = [];
    _.forEach(data, (row, index) => {
      if(skipFirstRow && index === 0) return;

      const option = {};
      _.forEach(structureKeys, ({ type, key, schema }) => {
        const cell = row.find((cell) => {
          return cell.field === key;
        })

        if(cell) {
          const value = cell.value instanceof Array ? cell.value: _.trim(cell.value);
          switch(type) {
            case 'transformTo':
              option[key] = this.transformTo(value, schema, false);
              break;
            case 'array':
              const list = _.split(value, ',');
              option[key] = _.chain(list).map(value => {
                return _.trim(value);
              }).filter(value => {
                return !_.isEmpty(value);
              }).value();
              break;
            case 'datetime':
              try {
                const datetime = new Date(value);
                option[key] = datetime.toJSON() === null ? value: datetime;
              } catch(e) {
                option[key] = value;
              }
              break;
            case 'number':
              option[key] = parseFloat(value);
              break;
            case 'boolean':
              const TrueValue = new RegExp(/^(yes|true|1)$/i);
              const FalseValue = new RegExp(/^(no|false|0|)$/i);
              if (_.isBoolean(value)) {
                option[key] = value;
              } else if (_.isNull(TrueValue.exec(value)) === false) {
                option[key] = true;
              } else if (_.isNull(FalseValue.exec(value)) === false) {
                option[key] = false;
              } else {
                option[key] = null;
              }
              break;
            case 'string':
              option[key] = value;
              break;
            default:
              option[key] = value;
          }
        }
      });
      result.push(option);
    })
    return result;
  }

  initializeForm(form: UntypedFormGroup, data: any, structure: any) {
    if(form === null) {
      return;
    }

    //send the form status to valid
    const structureKeys = [];

    const arrays = _.get(structure, 'arrays', []);
    _.forEach(arrays, ({array: key}) => structureKeys.push({'type':'array', key }));
    const fields = _.get(structure, 'fields', []);
    _.forEach(fields, ({field: key}) => structureKeys.push({'type':'field', key }));
    const groups = _.get(structure, 'groups', []);
    _.forEach(groups, ({group: key}) => structureKeys.push({'type':'group', key }));

    const keys = _.keys(form.controls);
    _.forEach(keys, key => {
      const formElement = form.get(key);
      const link = _.find(structureKeys, { key });
      const structureElement = _.find(structure[`${link.type}s`], {[link.type]: link.key});

      if(link.type === 'array') {
        const clonedArrayValue = _.cloneDeep(structureElement.value);
        const list = _.get(data, link.key, clonedArrayValue);
        _.forEach(list, listElement => {
          const formgGroup = new UntypedFormGroup({}, []);
          this.generateForm(formgGroup, structureElement.schema);
          this.initializeForm(formgGroup, listElement, structureElement.schema);
          (<UntypedFormArray>formElement).push(formgGroup);
        });

        const arrauDefaultValidators = _.get(structureElement, 'validators', []);
        const arrayValidatorsFunction = _.get(structureElement, 'options.validators', (data, value) => arrauDefaultValidators);
        const arrayValidatorsFunctionResult = arrayValidatorsFunction(data, list);

        formElement.clearValidators();
        formElement.setValidators(arrayValidatorsFunctionResult);
      }

      if(link.type === 'field') {
        let value = _.get(data, link.key, structureElement.value);
        if(_.isArray(value)) {
          value = _.cloneDeep(value);
        } else if(_.isFunction(value)) {
          value = value;
        } else if(_.isObject(value)) {
          value = _.cloneDeep(value);
        }

        const defaultValidators = _.get(structureElement, 'validators', []);
        const validatorsFunction = _.get(structureElement, 'options.validators', (data, value) => defaultValidators);
        const validatorsFunctionResult = validatorsFunction(data, value);

        formElement.clearValidators();
        formElement.setValidators(validatorsFunctionResult);

        const setterFunction = _.get(structureElement, 'options.setter', (data, value) => value);
        const setterFunctionResult = setterFunction(data, value);

        formElement.setValue(setterFunctionResult);
      }

      if(link.type === 'group') {
        const dataElement = _.get(data, link.key);
        this.initializeForm(formElement as UntypedFormGroup, dataElement, structureElement);
      }
    });
  }

  generateRequestObject(form: UntypedFormGroup, structure: any, rawObject: any = null, skip: string[] = [], path: string = '') {
    const isSkipped = _.find(skip, element => {
      return path.includes(element);
    }) || null;

    const requestObject = {};
    const structureKeys = [];

    if(isSkipped) {
      return requestObject;
    }

    const arrays = _.get(structure, 'arrays', []);
    _.forEach(arrays, ({array: key}) => structureKeys.push({'type':'array', key }));
    const fields = _.get(structure, 'fields', []);
    _.forEach(fields, ({field: key}) => structureKeys.push({'type':'field', key }));
    const groups = _.get(structure, 'groups', []);
    _.forEach(groups, ({group: key}) => structureKeys.push({'type':'group', key }));

    const keys = _.keys(form.controls);
    _.forEach(keys, key => {
      const rawElement = rawObject ? rawObject[key]: null;
      const formElement = form.get(key);

      const link = _.find(structureKeys, { key }) || false;
      if(link === false) return;

      const element = _.find(structure[`${link.type}s`], {[link.type]: link.key});
      const virtual = _.get(element, 'options.virtual', false);

      if(link.type === 'array') {
        const list = [];
        let formElementLength = 0;
        _.forEach((<UntypedFormArray>formElement).controls, (control, key) => {
          const requestObject = this.generateRequestObject(control, element.schema, rawElement, skip, path === '' ? `${link.key}.key`: `${path}.${link.key}.${key}`);
          list.push(requestObject);
          formElementLength++;
        });

        if(rawElement && key === "presetOptions") {
          for(let i = formElementLength; i < rawElement.length; i++) {
            list.push(rawElement[i]);
          }
        }

        if(virtual === false) {
          _.set(requestObject, link.key, list);
        }
      }

      if(link.type === 'field') {
        const getterFunction = _.get(element, 'options.getter', (control) => {
          return control.value;
        });
        const getterFunctionResult = getterFunction(formElement, form);

        if(virtual === false) {
          _.set(requestObject, link.key, getterFunctionResult);
        }
      }

      if(link.type === 'group') {
        if(path === '') {
          path = link.key;
        } else {
          path += `.${link.key}`;
        }
        const generateRequestObjectResult = this.generateRequestObject(formElement as UntypedFormGroup, element, rawElement, skip, path);
        if(virtual === false){
          _.set(requestObject, link.key, generateRequestObjectResult);
        }
      }

    });

    return requestObject;
  }

  isFormValid(campaign: UntypedFormGroup | UntypedFormArray, exclude: string[] = []): boolean {
    const list = _.map(campaign.controls, (control: UntypedFormControl | UntypedFormGroup | UntypedFormArray, key) => {
      const includes = _.includes(exclude, key);
      if(includes) {
        return true;
      };
      if(control instanceof UntypedFormGroup) {
        return this.isFormValid(control, exclude);
      }
      if(control instanceof UntypedFormArray) {
        return this.isFormValid(control, exclude);
      }
      return !control.invalid;
    });
    return _.every(list, (value) => {
      return _.isEqual(value, true);
    });
  }

  getOrganizationImages(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    this.loadingService.enabled = false;
    return this.http.post('/api/org-images/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));;
  }

  generateThumbnail(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/ai/thumb/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  generateCSummary(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/ai/summary/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

}
